import ReportsDownloadForm from "components/organisms/common/ReportsDownloadForm"
import Hero from "components/organisms/annual-reports/Hero"
import SEO from "components/seo"
import useTranslations from "hooks/useTranslations"
import { siteCountry } from "utils/env"

const getFirstNonEmpty = (...values: Array<string | undefined>) =>
  values.find((value) => typeof value === "string" && value.trim().length > 0)

const Reports = () => {
  const {
    menuLinkPublications,
    report2025HeroTitle,
    report2025HeroDescription,
    report2025HeroAvailabilityNote,
    report2025HeroStartButton,
    report2025HeroOlderReportsButton,
    report2025,
  } = useTranslations()

  const heroTitle = getFirstNonEmpty(
    report2025?.title,
    report2025HeroTitle,
  )
  const heroDescription = getFirstNonEmpty(
    report2025HeroDescription,
    report2025?.subtitle,
  )
  const heroStartCta = getFirstNonEmpty(
    report2025?.startCoverCta,
    report2025HeroStartButton,
  )
  const heroReadOlderReports = getFirstNonEmpty(
    report2025HeroOlderReportsButton,
    report2025?.readOlderReports,
  )
  const heroAvailabilityNote = getFirstNonEmpty(report2025HeroAvailabilityNote) || ""

  return (
    <div>
      <SEO title={menuLinkPublications} />
      <Hero
        title={heroTitle || ""}
        description={heroDescription || ""}
        noteText={heroAvailabilityNote}
        startCoverCta={heroStartCta || ""}
        readOlderReports={heroReadOlderReports || ""}
        showOlderReportsButton={siteCountry === "fi"}
      />
      {siteCountry === "fi" && <ReportsDownloadForm location="page" />}
    </div>
  )
}

export default Reports
